import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { authLayoutRoute } from '../layouts/auth-layout-route';

export const loginRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/login',
  component: lazyRouteComponent(() => import('@/pages/auth/login-page')),
});
